import { CommonModule } from '@angular/common'
import { Component, Input, OnChanges, OnInit } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { NzDividerModule } from 'ng-zorro-antd/divider'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzTagModule } from 'ng-zorro-antd/tag'
import { forkJoin } from 'rxjs'
import { AtomModule } from '../../atom/atom.module'
import { Asset, Product, SearchResult } from '../../gql/generated'
import { AcfService } from '../../service/acf.service'
import { AssetService } from '../../service/asset.service'
import { ProductService } from '../../service/product.service'

@Component({
  selector: 'app-game-card-beta',
  templateUrl: './game-card-beta.component.html',
  styleUrl: './game-card-beta.component.less',
  standalone: true,
  imports: [
    AtomModule,
    NzTagModule,
    NzDividerModule,
    NzIconModule,
    CommonModule,
    RouterModule,
  ],
})
export class GameCardBetaComponent implements OnInit, OnChanges {
  @Input() data!: SearchResult
  @Input() isSM = false

  product: Product

  developer: string
  publisher: string
  releaseDate: string
  videoAsset: Asset
  mainAsset: Asset
  logoAsset: Asset
  discountPercentage = 0
  isNew = false
  reviewCount = 2657
  rating = 'Very Positive'

  visiblePlatforms = [
    { label: 'PC', icon: 'ng-zorro:pc' },
    { label: 'Playstation', icon: 'ng-zorro:playstation' },
  ]

  platforms = [
    { label: 'Nintendo', icon: 'ng-zorro:nintendo' },
    { label: 'Playstation', icon: 'ng-zorro:playstation' },
    { label: 'Xbox', icon: 'ng-zorro:xbox' },
    { label: 'PC', icon: 'ng-zorro:pc' },
  ]

  constructor(
    private router: Router,
    private productService: ProductService,
    private acfService: AcfService,
    private assetService: AssetService
  ) {}

  ngOnInit(): void {
    // this.fetch()
    console.log('ngOnInit')
  }

  ngOnChanges() {
    this.fetch()
  }

  fetch(): void {
    console.log(this.data)
    const entityName = 'Product'
    const entityId = this.data.productId

    if (this.data && this.data.productId) {
      // Create observable for parallel execution
      forkJoin({
        product: this.productService.fetchProduct(this.data.slug),
        // developer: this.acfService.getNestedValue<string>(entityName, entityId, 'gameInformation.gameInformationDeveloper'),
        // publisher: this.acfService.getNestedValue<string>(entityName, entityId, 'gameInformation.gameInformationPublisher'),
        // releaseDate: this.acfService.getNestedValue<string>(entityName, entityId, 'gameInformation.gameInformationReleaseDate'),
        // discountPercentage: this.acfService.getNestedValue<number>(entityName, entityId, 'gameCardContent.discountPercentage'),
        // videoAsset: this.acfService.getNestedValue<Asset>(entityName, entityId, 'gameCardContent.videoAsset'),
        // mainAsset: this.acfService.getNestedValue<Asset>(entityName, entityId, 'gameCardContent.mainAsset'),
        // logoAsset: this.acfService.getNestedValue<Asset>(entityName, entityId, 'gameCardContent.logoAsset'),
        // isNew: this.acfService.getNestedValue<boolean>(entityName, entityId, 'gameCardContent.isNew'),
        // rating: this.acfService.getNestedValue<string>(entityName, entityId, 'gameInformation.rating'),
        // reviewCount: this.acfService.getNestedValue<number>(entityName, entityId, 'gameInformation.reviewCount')
      }).subscribe((results) => {
        this.product = results.product as Product
        // this.developer = results.developer
        // this.publisher = results.publisher
        // this.releaseDate = results.releaseDate || '2024-06-31'
        // this.discountPercentage = results.discountPercentage || 10
        // this.videoAsset = results.videoAsset
        // this.mainAsset = results.mainAsset
        // this.logoAsset = results.logoAsset
        // this.isNew = results.isNew || false
        // this.rating = results.rating || 'Very Positive'
        // this.reviewCount = results.reviewCount || 2657

        // Determine visible platforms (can be enhanced with actual logic)
        this.setVisiblePlatforms()
      })
    }
  }

  getDiscountedPrice(): number {
    if (
      !this.product ||
      !this.product.variants ||
      !this.product.variants.length
    ) {
      return 0
    }

    const originalPrice = this.product.variants[0].price
    if (this.discountPercentage <= 0) {
      return originalPrice
    }

    return originalPrice * (1 - this.discountPercentage / 100)
  }

  setVisiblePlatforms(): void {
    // This method would determine which platforms to show based on the product
    // For now, we're using fixed platforms from the design
    this.visiblePlatforms = [
      { label: 'PC', icon: 'ng-zorro:pc' },
      { label: 'Playstation', icon: 'ng-zorro:playstation' },
    ]
  }

  onTagClick(
    event: Event,
    facetValue: { facet: { name: string }; code: string }
  ) {
    event.stopPropagation()
    event.preventDefault()
    this.router.navigate(['/category'], {
      queryParams: { [facetValue.facet.name]: facetValue.code },
    })
  }

  formatReviewCount(count: number): string {
    return count.toLocaleString()
  }

  formatDate(dateString: string): string {
    if (!dateString) return ''

    const date = new Date(dateString)
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    const month = months[date.getMonth()]
    const day = date.getDate()
    const year = date.getFullYear()

    // Format: "Sep 6, 2024" -> "Sep 6 2024" (no comma, as shown in screenshot)
    return `${month} ${day} ${year}`
  }
}
